<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <div class="u-f u-ac u-jsb">
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" :height="height" border v-loading="loading">
                <el-table-column prop="id" label="编号" width="70"></el-table-column>
                <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="min_price" label="最低价格"></el-table-column>
                <el-table-column prop="start_time" label="生效日期"></el-table-column>
                <el-table-column prop="end_time" label="失效日期"></el-table-column>
                <el-table-column prop="total" label="总数"></el-table-column>
                <el-table-column prop="fraction" label="类型">
                    <template slot-scope="scope">
                        <span>{{({0:'满减',1:'折扣'})[scope.row.type]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="growth_value" label="状态">
                    <template slot-scope="scope">
                        <span>{{({0:'不生效',1:'生效'})[scope.row.status]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="growth_value" label="系统默认优惠券">
                    <template slot-scope="scope">
                        <span>{{({1:'是',2:'否'})[scope.row.sys_default]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="growth_value" label="使用渠道">
                    <template slot-scope="scope">
                        <span>{{({1:'通用',2:'消费后赠送',3:'抽奖专用'})[scope.row.use_channel]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="growth_value" label="赠送">
                    <template slot-scope="scope">
                        <span>
                            <el-button type="text" @click="zsyhq(scope.row)">选择用户</el-button>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="growth_value" label="指定商品">
                    <template slot-scope="scope">
                        <span>
                            <el-button type="text" @click="selectgoods(scope.row)">选择商品</el-button>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="130" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="优惠券设置" :visible.sync="dialogVisible" center top="20px" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="优惠券名称" prop='name'>
                        <el-input v-model="ruleForm.name" size="small" style="max-width:200px"></el-input> <span style="color:red">（字数不要过多，尽量6字以内）</span>
                    </el-form-item>
                    <el-form-item label="是否生效" prop='status'>
                        <el-select v-model="ruleForm.status" placeholder="请选择" size="small">
                            <el-option v-for="item in state_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类型" prop='type'>
                        <el-select v-model="ruleForm.type" placeholder="请选择" size="small">
                            <el-option v-for="item in type_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="使用渠道">
                        <el-radio-group v-model="ruleForm.use_channel" @change="selectusechannel">
                            <el-radio :label="1">通用</el-radio>
                            <el-radio :label="2">消费后赠送</el-radio>
                            <el-radio :label="3">抽奖专用</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="总数" prop='total'>
                        <el-input v-model="ruleForm.total" size="small" :disabled='ruleForm.use_channel==3' style="max-width:200px"></el-input>
                    </el-form-item>
                    <el-form-item label="商品最低价" prop='min_price'>
                        <el-input v-model="ruleForm.min_price" size="small" style="max-width:200px"></el-input> <span style="color:red">（这个数要低于商品价）</span>
                    </el-form-item>
                    <el-form-item label="优惠券价值" prop='value'>
                        <el-input v-model="ruleForm.value" size="small"  style="max-width:200px"></el-input> <span style="color:red">（优惠券可优惠的金额）</span>
                    </el-form-item>
                    <el-form-item label="到期类型">
                        <el-radio-group v-model="ruleForm.expire_type" @change="changeexpire_type">
                            <el-radio :label="1">指定时间</el-radio>
                            <el-radio :label="2">指定领取后天数</el-radio>
                            <el-radio :label="3">不限</el-radio><a href=""></a>
                        </el-radio-group>
                    </el-form-item>
                    <template v-if="ruleForm.expire_type!=3">
                        <el-form-item label="领取后到期天数" v-if="ruleForm.expire_type==2" prop="expire_day">
                            <el-input type="number" size="small" v-model="ruleForm.expire_day" min="0">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="开始日期" prop="start_time"
                            :rules="[{required:ruleForm.expire_type==1,message:'请选择开始日期',trigger:'blur'}]">
                            <el-date-picker v-model="ruleForm.start_time" type="date" size="small"
                                value-format="yyyy-MM-dd" placeholder="选择开始日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束日期" prop="end_time"
                            :rules="[{required:ruleForm.expire_type==1,message:'请选择结束日期',trigger:'blur'}]">
                            <el-date-picker v-model="ruleForm.end_time" type="date" size="small"
                                value-format="yyyy-MM-dd" placeholder="选择结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </template>

                    <el-form-item label="排序">
                        <el-input placeholder="请输入内容" type="number" size="small" v-model="ruleForm.order">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="ruleForm.desc">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="系统默认优惠券">
                        <el-radio-group v-model="ruleForm.sys_default">
                            <el-radio :label="1" :disabled='ruleForm.use_channel==3'>是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否可领取(所有用户)">
                        <el-radio-group v-model="ruleForm.show_cardcenter">
                            <el-radio :label="1" :disabled='ruleForm.use_channel==3'>是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>

                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 选择用户 -->
        <el-dialog title="选择用户" width="80%" :visible.sync="zsdialoged" @close='closedialo' top="20px" center
            class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" label-width="140px" class="demo-ruleForm" inline>
                    <el-form-item label="选择用户">
                        <el-form-item>
                            <el-input v-model="userkeyword" placeholder="请输入昵称、手机号" style="width:200px" clearable
                                size="small"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="searchusers">搜索
                            </el-button>
                        </el-form-item>
                        <el-form-item label="赠送数量">
                            <el-input v-model="zs_count" placeholder="请输入赠送数量" style="width:200px" min="1" size="small"
                                type="number"></el-input>
                        </el-form-item>
                    </el-form-item>
                </el-form>
                <div class="u-f">
                    <div style="width:50%">
                        <el-table :data="userTableData" border v-loading="loading" height="430"
                            ref="configurationTables" @selection-change="handleSelectionChange" :row-key="getRowKeys">
                            <el-table-column type="selection" width="55" :reserve-selection="true" />
                            <el-table-column prop="title" label="头像" show-overfl ow-tooltip>
                                <template slot-scope="scope">
                                    <img :src="scope.row.doctorAudit?scope.row.doctorAudit.head_portrait_pic[0].url:scope.row.avatar"
                                        alt="" width="50" class="tablimg">
                                </template>
                            </el-table-column>
                            <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>{{scope.row.doctorAudit?scope.row.doctorAudit.real_name:scope.row.nickname}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="u-f u-ac u-jsb ft_mr">
                            <div></div>
                            <div>
                                <el-pagination @size-change="userhandleSizeChange"
                                    @current-change="userhandleCurrentChange" :current-page="usercurrentPage"
                                    :page-sizes="[10, 20, 30, 40]" :page-size="userpagesize"
                                    layout="total, sizes, prev, pager, next" :total="usercount">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                    <div style="width:50%;margin-left:10px">
                        <el-table :data="sendusers" border v-loading="loading" height="430" ref="configurationTable">
                            <el-table-column prop="title" label="头像" show-overfl ow-tooltip>
                                <template slot-scope="scope">
                                    <img :src="scope.row.doctorAudit?scope.row.doctorAudit.head_portrait_pic[0].url:scope.row.avatar"
                                        alt="" width="50" class="tablimg">
                                </template>
                            </el-table-column>
                            <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>{{scope.row.doctorAudit?scope.row.doctorAudit.real_name:scope.row.nickname}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submited()" :loading='sendloading' size="small">确 定</el-button>
                <el-button @click="zsdialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 选择商品 -->
        <el-dialog title="选择商品" width="80%" :visible.sync="goodsdialoged" @close='goodsclosedialo' top="20px" center
            class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" label-width="140px" class="demo-ruleForm" inline>
                    <el-form-item label="选择商品">
                        <el-form-item>
                            <el-input v-model="goodskeyword" placeholder="请输入名称" style="width:200px" clearable
                                size="small"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="searchgoods">搜索
                            </el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="text" size="small" @click="allgoods">不限
                            </el-button> <span style="margin-left:10px">Tips:清除指定商品，设置为所有商品可用！</span>
                        </el-form-item>
                    </el-form-item>
                </el-form>
                <div style="padding:5px">如需更改指定商品请先点击“<span style="color:#5473E8">不限</span>”清除指定商品，若只添加指定商品则无需点击 </div>
                <div class="u-f">
                    <div style="width:50%">
                        <el-table :data="goodsTableData" border v-loading="loading" :height="goodsHeight"
                            ref="goodsTables" @selection-change="handleSelectionChangegoods" :row-key="getRowKeysGoods">
                            <el-table-column type="selection" width="55" :reserve-selection="true" />
                            <el-table-column prop="title" label="图片" width="80">
                                <template slot-scope="scope">
                                    <img :src="scope.row.cover[0].url" v-if="scope.row.cover" alt="" width="50"
                                        class="tablimg">
                                </template>
                            </el-table-column>
                            <el-table-column prop="title" label="类型" width="90">
                                <template slot-scope="scope">
                                    <el-tag type="danger" effect="dark" v-if="scope.row.category_id==392" size="mini">
                                        抢兑商品
                                    </el-tag>
                                    <el-tag type="" effect="plain" v-else size="mini">
                                        常规商品
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="title" label="名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="pprice" align="center" label=" 价格(元)" width="130">
                                <template slot-scope="scope">
                                    <span class="text-danger">￥{{ scope.row.min_price }}</span>
                                    <span>/</span>
                                    <span class="text-muted">￥{{ scope.row.min_oprice }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="status" align="center" label="商品状态" width="60">
                                <template slot-scope="scope">
                                    <span class="badge"
                                        :class="scope.row.status ? 'badge-success' : 'badge-danger'">{{ scope.row.status ? "上架" : "仓库" }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="u-f u-ac u-jsb ft_mr">
                            <div></div>
                            <div>
                                <el-pagination @size-change="goodsSizeChange" @current-change="goodsCurrentChange"
                                    :current-page="goodscurrentPage" :page-sizes="[10, 20, 30, 40]"
                                    :page-size="goodspagesize" layout="total, sizes, prev, pager, next"
                                    :total="goodscount">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                    <div style="width:50%;margin-left:10px">
                        <el-table :data="sendgoods" border v-loading="loading" :height="goodsHeight"
                            ref="configurationTable">
                            <el-table-column prop="title" label="图片" width="80">
                                <template slot-scope="scope">
                                    <img :src="scope.row.cover[0].url" v-if="scope.row.cover" alt="" width="50"
                                        class="tablimg">
                                </template>
                            </el-table-column>
                            <el-table-column prop="title" label="名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="pprice" align="center" label=" 价格(元)" width="130">
                                <template slot-scope="scope">
                                    <span class="text-danger">￥{{ scope.row.min_price }}</span>
                                    <span>/</span>
                                    <span class="text-muted">￥{{ scope.row.min_oprice }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="status" align="center" label="商品状态" width="60">
                                <template slot-scope="scope">
                                    <span class="badge"
                                        :class="scope.row.status ? 'badge-success' : 'badge-danger'">{{ scope.row.status ? "上架" : "仓库" }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitgoods()" :loading='sendloading' size="small">确 定</el-button>
                <el-button @click="goodsdialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                height: null,
                // 
                eid: '',
                dialogVisible: false,
                subloading: false,
                ruleForm: {
                    end_time: '',
                    start_time: '',
                    value: '',
                    min_price: '',
                    total: '',
                    type: '',
                    status: '',
                    name: '',
                    desc: '',
                    order: 50,
                    sys_default: 2,
                    use_channel: 1,
                    expire_day: 0,
                    expire_type: 1,
                    use_channel: 1,
                    show_cardcenter: 0,
                },

                rule: {
                    name: [{
                        required: true,
                        message: '请填写名称',
                        trigger: 'blur'
                    }],
                    status: [{
                        required: true,
                        message: '请选择是否生效',
                        trigger: 'blur'
                    }],
                    type: [{
                        required: true,
                        message: '请选择类型',
                        trigger: 'blur'
                    }],
                    total: [{
                        required: true,
                        message: '请填写优惠券总数',
                        trigger: 'blur'
                    }],
                    min_price: [{
                        required: true,
                        message: '请填写优惠券最低价',
                        trigger: 'blur'
                    }],
                    value: [{
                        required: true,
                        message: '请填写值',
                        trigger: 'blur'
                    }],

                    expire_day: [{
                        required: true,
                        message: '请填写过期天数',
                        trigger: 'blur'
                    }],
                    use_channel: [{
                        required: true,
                        message: '请选择',
                        trigger: 'blur'
                    }],
                },
                state_options: [{
                        id: 0,
                        name: '不生效'
                    },
                    {
                        id: 1,
                        name: '生效'
                    },
                ],
                type_options: [{
                        id: 0,
                        name: '满减'
                    },
                    {
                        id: 1,
                        name: '折扣'
                    },
                ],
                zsdialoged: false,
                userTableData: [],
                loading: false,
                usercurrentPage: 1,
                userpagesize: 10,
                usercount: 0,
                sendusers: [],
                userkeyword: '',
                lb_value: '',
                zs_count: 1,
                sendloading: false,
                // 选择商品
                goodsdialoged: false,
                goodsTableData: [],
                loading: false,
                goodscurrentPage: 1,
                goodspagesize: 10,
                goodscount: 0,
                sendgoods: [],
                goodskeyword: '',
                goods_count: 1,
                goodsHeight: null
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                that.goodsHeight = window.innerHeight - titles - 350 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                    that.goodsHeight = window.innerHeight - titles - 350 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios.get(`/admin/coupon/${this.currentPage}`, {
                        headers: {
                            token: this.user.token
                        }
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = ''
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm = {
                    end_time: '',
                    start_time: '',
                    value: '',
                    min_price: '',
                    total: '',
                    type: '',
                    status: '',
                    name: '',
                    desc: '',
                    order: 50,
                    sys_default: 2,
                    use_channel: 1,
                    expire_day: 0,
                    expire_type: 1,
                    show_cardcenter: 0,
                }
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.subloading = true
                        let urls;
                        if (this.eid) {
                            urls = `/admin/coupon/${that.eid}`
                        } else {
                            urls = "/admin/coupon"
                        }
                        axios.post(urls, that.ruleForm, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.msg == 'ok') {
                                    that.dialogVisible = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.dialogVisible = true
                that.eid = row.id
                this.ruleForm.end_time = row.end_time
                this.ruleForm.start_time = row.start_time
                this.ruleForm.value = row.value
                this.ruleForm.min_price = row.min_price
                this.ruleForm.total = row.total
                this.ruleForm.type = row.type
                this.ruleForm.status = row.status
                this.ruleForm.name = row.name
                this.ruleForm.desc = row.desc
                this.ruleForm.order = row.order
                this.ruleForm.sys_default = row.sys_default
                this.ruleForm.use_channel = row.use_channel
                this.ruleForm.expire_day = row.expire_day
                this.ruleForm.expire_type = row.expire_type
                this.ruleForm.show_cardcenter = row.show_cardcenter
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .delete(`/admin/coupon/${row.id}`, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            changeexpire_type() {
                if (this.ruleForm.expire_type == 1) {
                    this.ruleForm.expire_day = 0
                }
                if (this.ruleForm.expire_type == 3) {
                    this.ruleForm.expire_day = 0
                    this.ruleForm.start_time = ''
                    this.ruleForm.end_time = ''
                }
            },
            selectusechannel(n) {
                if (n == 3) {
                    this.ruleForm.total = 0
                    // this.ruleForm.expire_type = 3
                    this.ruleForm.expire_day = 0
                    this.ruleForm.start_time = ''
                    this.ruleForm.end_time = ''
                    this.ruleForm.sys_default = 2
                    this.ruleForm.show_cardcenter = 0
                }
            },
            zsyhq(row) {
                this.zsdialoged = true
                this.eid = row.id
                this.searchusers()
            },
            closedialo() {
                this.userkeyword = ''
                this.sendusers = []
                this.$nextTick(() => {
                    this.$refs.configurationTables.clearSelection();
                })
            },
            searchusers() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/User/userList", {
                        page: that.usercurrentPage,
                        page_count: that.userpagesize,
                        keyword: this.userkeyword,
                        customer_type: this.lb_value

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.userTableData = response.data.data.list
                        that.usercount = response.data.data.totalCount

                    })
                    .catch(error => {})
            },
            handleSelectionChange(val) {
                this.sendusers = val;
            },
            getRowKeys(row) {
                return row.id; // id为列表数据的唯一标识
            },
            userhandleSizeChange(val) {
                let that = this
                that.userpagesize = val;
                that.searchusers()
            },
            userhandleCurrentChange(val) {
                let that = this
                that.usercurrentPage = val;
                that.searchusers()
            },
            async submited() {
                let userids = this.sendusers.map(ele => ele.id);
                if (userids.length == 0) return this.$message.error('请选择用户')
                if (!this.zs_count || this.zs_count == 0) return this.$message.error('数量必须大于0')
                this.sendloading = true
                let res = await this.ajax('inquiry/coupon/couponGive', {
                    coupon_id: this.eid,
                    user_ids: userids,
                    count: this.zs_count,
                    type: 1
                })
                if (res.code == 200) {
                    this.$message.success('赠送成功')
                    this.zsdialoged = false
                } else {
                    this.$message(res.msg)
                }
                this.sendloading = false

            },
            // 指定商品
            selectgoods(row) {
                this.goodsdialoged = true
                this.eid = row.id
                this.searchgoods()
            },
            goodsclosedialo() {
                this.goodskeyword = ''
                this.sendgoods = []
                this.$nextTick(() => {
                    this.$refs.goodsTables.clearSelection();
                })
            },
            searchgoods() {
                let that = this
                that.loading = true
                this.axios
                    .get(
                        `/admin/goods/${this.goodscurrentPage}?limit=${this.goodspagesize}&tab=all&&title=${this.goodskeyword}`, {
                            token: true
                        })
                    .then(response => {
                        that.loading = false
                        that.goodsTableData = response.data.data.list
                        that.goodscount = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            handleSelectionChangegoods(val) {
                this.sendgoods = val;
            },
            getRowKeysGoods(row) {
                return row.id; // id为列表数据的唯一标识
            },
            goodsSizeChange(val) {
                let that = this
                that.goodspagesize = val;
                that.searchgoods()
            },
            goodsCurrentChange(val) {
                let that = this
                that.goodscurrentPage = val;
                that.searchgoods()
            },
            async submitgoods() {
                let userids = this.sendgoods.map(ele => ele.id);
                if (userids.length == 0) return this.$message.error('请选择商品')
                this.sendloading = true
                let res = await this.ajax('admin/coupon/couponGiveGoods', {
                    coupon_id: this.eid,
                    goods_id: userids,
                })
                if (res.code == 200) {
                    this.$message.success('设置成功')
                    this.goodsdialoged = false
                } else {
                    this.$message(res.msg)
                }
                this.sendloading = false

            },
            allgoods() {
                this.$confirm('此操作将此优惠券设置为所有商品可用, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let res = await this.ajax('admin/coupon/couponCleanGoods', {
                        coupon_id: this.eid,
                    })
                    if (res.code == 200) {
                        this.$message.success('设置成功')
                        this.goodsdialoged = false
                    } else {
                        this.$message(res.msg)
                    }
                    this.sendloading = false
                }).catch(() => {

                });
            },
        },

    };
</script>


<style scoped>
    .el-table__body-wrapper {
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>